<template>
	<!-- 专家详情 -->
	<div>
		<!-- <headView></headView> -->
		<!-- <Breadcrumb></Breadcrumb> -->
		<div class="" style="">
			<div class="coSucess" id="myDiv" v-show="scShow">
				收藏成功
			</div>
			<div class="pad-16 mb-16 box-shadow" style="color: #000000;height: 200px;">
				<div class="is-flex wid-100" style="margin-bottom: 24px;">
					<img src="../../assets/home/zhuanjia.png" alt="" style="width: 30px;">
					<div class="titles is-flex">
						<p class="tit-1">专家</p>
						<span>专家领域权威讲解</span>
					</div>
				</div>
				<!-- <div> -->
				<!-- <img src="../../assets/home/Rectangle 4.png" alt=""> -->
				<div class="is-flex mb-24" style="align-items: flex-start">
					<div class="hed-img">
						<img :src="details.avatar" alt="" style="width: 8vw;height: 8vw;">
					</div>
					<div class="is-flex" style="width: 100%;padding: 19px 0;justify-content: space-between;">
						<div>
							<div class="is-flex mb-8">
								<p class="name-1">{{details.name}}</p>
								<!-- <img :src="item.img" alt="" class="sex-img"> -->
								<!-- <img src="/src/assets/expert/nv.png" alt=""> -->
								<!-- ../../assets/head/Frame 2333.png -->

								<img v-if="details.remunerationRangeList" :src="details.remunerationRangeList[0].content" alt="" class="sex-img"
									@click="iconClick">
							</div>
							<div class="is-flex mb-8">
								<p class="name-2">工作单位:</p>
								<p class="name-3">{{ details.company}}</p>
							</div>
							<div class="mb-8" style="display: flex;">
								<p class="name-2">擅长领域:</p>
								<div style="display: flex;flex-wrap: wrap;">
									<p class="name-3" v-for="(ite1,inde1) in details.fieldList">
										{{ite1.name}}<span v-if="inde1<details.fieldList.length-1">、</span>
									</p><span class="name-3" v-if="details.fieldInfo">、</span><span class="name-3"
										v-if="details.fieldInfo">{{details.fieldInfo}}</span>
								</div>
							</div>
						</div>
						<div class="dianji">
							<div class="cool-1 is-flex mb-24 cursor" v-show="details.collectStatus == false"
								@click="collectZj(details.id)">
								<img src="../../assets/expert/collect-1.png" alt="">
								<p class="name-4">
									收藏专家
								</p>
							</div>
							<div class="cool-1 is-flex mb-24 cursor"
								style="background-color: #FBF5EC;border: 1px solid #FFFFFF;"
								v-show="details.collectStatus == true" @click="collectQx(details.id)">
								<img src="../../assets/expert/collect-2.png" alt="">
								<p class="name-4">
									已收藏
								</p>
							</div>

							<div class="cool-2 is-flex" @click="unlock(userInfo.userLevelStatus)">
								<img src="../../assets/expert/dianhua.png" alt="">
								<p class="name-3">
									联系专家
								</p>
							</div>
						</div>
						<!--  -->



						<!-- </div> -->

					</div>

				</div>

			</div>
			<div class="is-flex flex-tab mb-16">
				<p v-for="(item,index) in tpData" @click="systemChange(item,index)"
					:class="selectedIndex == index ? 'p-active':''">
					{{item.name}}
				</p>
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId1" v-if="details.moduleStatus && details.moduleContent">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">专家介绍</p>
				</div>
				<div class="is-flex mb-16 align-base">
					<p class="name-2">简介:</p>
					<p class="name-3" v-html="details.moduleContent.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\r/g, '<br/>').replace(/\s/g, '&nbsp;')">
					</p>
				</div>
				<div class="is-flex goodat">
					<!-- <p>小学</p>
                    <p>数学</p> -->

					<p>{{details.provinceName}}</p>
					<p v-if="details.cityName!='市辖区'">{{details.cityName}}</p>
					<p v-for="(it,index) in educationStageList">
						{{it}}
					</p>
					<p v-for="(it,index) in subjectList">
						{{it}}
					</p>
					<!-- <p>郑州市第一中学</p> -->
					<!-- <p>{{details.company}}</p> -->
				</div>
			</div>
			<div class="pad-16 mb-16 box-shadow" id="bayId2" v-show="details.mainCourseStatus && details.mainCourse && details.mainCourse.length>0">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">主讲课程</p>
				</div>
				<!-- 主讲课程只需开通会员 不需要解锁 （开通后/会员） 即可查看 -->
				<!-- 已解锁 -->
				<div class="yijiesuo"
					v-show="details.mainCourseStatus&&(userInfo.userLevelStatus || userInfo.vipStatus)">
					<div class="mb-16" v-for="(item1,index1) in details.mainCourse">
						<p class="title-p mb-12">{{index1+1}}.{{item1.title}}</p>
						<div class="is-flex mb-12 align-base">
							<p class="name-2">主要内容:</p>
							<p class="name-3">
								{{item1.content}}
							</p>
						</div>
						<div class="is-flex align-base">
							<p class="name-2">适合对象:</p>
							<p class="name-3">{{item1.applicableUser}}</p>
						</div>
					</div>
				</div>

				<!-- 未解锁 -->
				<div class="is-flex jus-bet"
					v-show="details.mainCourseStatus&&!userInfo.userLevelStatus&&!userInfo.vipStatus">
					<div></div>
					<div class="is-flex jiesuo-1" @click="unlock(2)">
						<img src="../../assets/expert/jiesuo.png" alt="" style="width: 19px;height: 19px;">
						<p>点击可查看专家的主讲课程介绍</p>
					</div>
					<div></div>
				</div>


			</div>
			<!-- 精彩视频 -->
			<div class="pad-16 mb-16 box-shadow" id="bayId3"
				v-show="details.displayStatus && videoList && videoList.length>0">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">精彩视频</p>
				</div>
				<div class="is-flex mb-16 videos" style="flex-wrap: wrap;"
				v-show="userInfo.userLevelStatus || userInfo.vipStatus"
				>
					<div v-for="(item,index) in videoList"
						style="margin-right: 20px;width: 200px;margin-bottom: 20px;">
						<img v-if="!item.videoUrl" :src="item.coverImage" style="width: 200px;height: 120px;" alt=""
							@click="goUrl(item)">
						<video v-if="item.videoUrl" :show-fullscreen-btn="true" :poster="item.coverImage"
							:src="item.videoUrl" style="width: 200px;height: 120px;" controls="controls"></video>
						<p class="title-p" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.title}}</p>
					</div>
					<!-- <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div>
                    <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div>
                    <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div> -->
				</div>
				<!-- <div class="is-flex jus-bet">
					<div></div>
					<div class="is-flex more" @click="">
						<p>查看更多</p>
						<i class="el-icon-arrow-down"></i>
					</div>
					<div></div>
				</div> -->
				<!-- 未解锁 -->
				<div class="is-flex jus-bet"
					v-show="!userInfo.userLevelStatus&&!userInfo.vipStatus">
					<div></div>
					<div class="is-flex jiesuo-1" @click="unlock(2)">
						<img src="../../assets/expert/jiesuo.png" alt="" style="width: 19px;height: 19px;">
						<p>点击可查看专家的精彩视频</p>
					</div>
					<div></div>
				</div>
			</div>
			<!-- 授课风采 -->
			<div class="pad-16 mb-16 box-shadow" id="bayId4" v-if="details.teachingStyleStatus && details.teachingStyle">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">授课风采</p>
				</div>
				<div class="is-flex jus-bet mb-16 videos">
					<!-- {{details.teachingStyle}} -->
					<div class="ql-editor">
						<div style="margin-top: 24px;" v-html="details.teachingStyle"></div>
					</div>
					<!-- <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div>
                    <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div>
                    <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div>
                    <div>
                        <img src="../../assets/home/Frame 2543.png" alt="" style="">
                        <p class="title-p">培养家长满意的自主发展下一代</p>
                    </div> -->
				</div>
				<!-- 	<div class="is-flex jus-bet">
					<div></div>
					<div class="is-flex more" @click="">
						<p>查看更多</p>
						<i class="el-icon-arrow-down"></i>
					</div>
					<div></div>
				</div> -->
			</div>
			<!-- 授课案例 -->
			<div class="pad-16 mb-16 box-shadow" id="bayId5" v-if="details.teachingCaseStatus && details.teachingCase && details.teachingCase.length>0">
				<div class="is-flex mb-16">
					<div class="left-icon"></div>
					<p class="left-p">授课案例</p>
				</div>
				<div class="is-flex jus-bet lists-1" v-for="(item1,index1) in details.teachingCase">
					<p>{{item1.content}}</p>
					<p>{{item1.createTime}}</p>
				</div>
			</div>
			<div class="dianji is-flex  jus-bet">
				<div></div>
				<div class="is-flex">
					<div class="cool-3 is-flex cursor" v-if="!details.collectStatus" @click="collectZj(details.id)">
						<img src="../../assets/expert/collect-1.png" alt="">
						<p class="name-4">
							收藏专家
						</p>
					</div>
					<div class="cool-3 is-flex cursor" style="background-color: #FBB54C;border: 1px solid #FFFFFF;"
						v-if="details.collectStatus" @click="collectQx(details.id)">
						<!-- <img src="../../assets/expert/collect-2.png" alt=""> -->
						<img src="../../assets/expert/xing.png" alt="" />
						<p class="name-4" style="color: #FFFFFF;">
							已收藏
						</p>
					</div>


					<div class="cool-4 is-flex cursor" @click="unlock(userInfo.userLevelStatus)">
						<!-- <img src="../../assets/expert/dianhua.png" alt=""> -->
						<img src="../../assets/expert/lian-1.png" alt="">
						<p class="name-3">
							联系专家
						</p>
					</div>
				</div>
				<div></div>
			</div>
			<!--  -->
			<!-- 开通会员弹窗 -->
			<el-dialog title="" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">

				<div class="is-flex jus-bet">
					<div></div>
					<div class="vip">
						<img src="../../assets/expert/close-1.png" alt="">
						<p class="vip-p"><span class="vip-span">开通会员</span>{{vip==1 ? vipTitle :vipTitle1 }}</p>
						<p class="kaitong" @click="activate">开通会员</p>
					</div>
					<div></div>
				</div>

				<!-- <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                  </span> -->
			</el-dialog>
			<!--解锁提示-->
			<el-dialog title="" :visible.sync="dialogVisibleTitle" width="30%" :before-close="handleClose">
				<div class="is-flex jus-bet">
					<div></div>
					<div class="vip">
						<p class="vip-p mb-16" style="color: #3377FF;">将使用1个解锁名额 剩余{{Math.max(nums - 1, 0)}}个</p>
						<p class="vip-span-1">解锁后可立即添加<span v-if="details.isPublicContact">专家</span><span
								v-if="!details.isPublicContact">专家助教</span>微信</p>
						<div class="is-flex jus-bet">
							<p class="cancel" @click="dialogVisibleTitle = false">取消</p>
							<p class="kaitong" style="width: auto;margin-top: 0;" @click="immediately(details.id)">立即解锁
							</p>
						</div>
					</div>
					<div></div>
				</div>
			</el-dialog>
			<!-- 解锁弹窗 -->
			<el-dialog title="" :visible.sync="dialogImmediately" width="30%" :before-close="handleClose">

				<div class="vip">
					<p class="vip-p mb-16">解锁成功!可在 <span class="vip-span">
							<我的-我的服务-我的专家>
						</span>中查看您解锁的专家</p>
					<!-- assistantQrcode 助教二维码 -->
					<!-- <img :src="details.expertQrcode==null?details.assistantQrcode:details.expertQrcode" alt=""
						class="mb-16" style="width: 30%;"> -->
					<div style="text-align: center;">
						<img :src="details.expertQrcode" alt="" class="mb-16" style="width: 30%;"
							v-if="details.isPublicContact">
						<img :src="details.assistantQrcode" alt="" class="mb-16" style="width: 30%;"
							v-if="!details.isPublicContact">
					</div>
					<p class="vip-1">使用手机微信扫码，立即添加{{details.isPublicContact?'专家':'专家助教'}}微信</p>
					<div class="is-flex jus-bet mb-16">
						<p class="vip-p">快速联系</p>
						<div class="is-flex ctrl-c">
							<p>复制文案</p>
							<img src="../../assets/expert/ctrlc.png" alt="" @click="copy">
						</div>
					</div>
					<p class="vip-1" style="text-align: justify;">{{texart}}</p>
					<!-- <p class="vip-p"><span class="vip-span">开通会员</span>{{vip==1 ? vipTitle :vipTitle1 }}</p> -->
					<div class="is-flex jus-bet">
						<!-- <div></div> -->
						<p class="kaitong" style="width: auto;margin-top: 0;" @click="handleClose">我知道了</p>
						<!-- <div></div> -->
					</div>
				</div>
			</el-dialog>
			<!-- 会员图标 -->
			<el-dialog title="" :visible.sync="iconShow" width="30%" :show-close="false">
				<div class="member-icon">
					<div class="member-title">
						课酬区间（每半天）
					</div>
					<div class="member-list">
						<div class="member-item" v-for="(item,index) in typeList">
							<span class="member-span">{{item.name}}</span>
							<img class="member-img" :src="item.content" mode=""></img>
						</div>
					</div>
					<div class="member-btn" @click="iconShow = false">
						我知道了
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- <footers></footers> -->
	</div>
</template>

<script>
	import {
		getDetail,
		getUserCollect,
		getDeleteCollect,
		getUserNum,
		getUnlock
	} from '@/api/expert/api.js';
	import {
		getInfo,
		getMyLevel
	} from '@/api/api.js';
	import headView from '@/views/headView.vue';
	import footers from '@/views/footers.vue';
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import {
		getSystemType
	} from '@/api/api.js';
	export default {
		components: {
			headView,
			footers,
			Breadcrumb
		},
		data() {
			return {
				show1: false,
				dialogVisible: false,
				dialogVisibleTitle: false,
				dialogImmediately: false,
				iconShow: false,
				vip: 0,
				vipTitle1: '可查看专家的主讲课程介绍',
				vipTitle: '解锁专家联系方式',
				texart: '你好，我是中国专家网的用户，有讲课需求要跟您具体沟通，请通过好友申请',
				tpData: [{
						name: '专家介绍',
						id: 'bayId1',
					},
					{
						name: '主讲课程',
						id: 'bayId2',
					},
					{
						name: '精彩视频',
						id: 'bayId3',
					},
					{
						name: '授课风采',
						id: 'bayId4',
					},
					{
						name: '授课案例',
						id: 'bayId5',
					}
				],
				selectedIndex: 0,
				details: {
					labelName: '',
					avatar: '',
					company: '',
					field: '',
					moduleContent: '',
					collectStatus: '',
					mainCourseStatus: '',
					remunerationRangeList: [{
						content: ''
					}],
					provinceName: '',
					cityName: '',
					mainCourse: [],
					teachingStyle: '',
					teachingCase: []
				},
				educationStageList: [],
				subjectList: [],
				scShow: false,
				videoList: [],
				userInfo: '',
				nums: '',
				isshows: false,
				quickContact: '',
				typeList: [],
			}
		},
		created() {
			this.userInfo = this.$store.state.activity.user;
		},
		mounted() {
			this.zjId = this.$route.params.id;
			this.getDetat(this.$route.params.id);
			this.getNum();
			this.getInfoData();
			this.getTypeList();
		},
		methods: {
			getTypeList() {
				getSystemType({
					type: 4
				}).then(res => {
					this.typeList = res.data;
				})
			},
			iconClick() {
				// 判断是否登录
				let token = localStorage.getItem('keyToken');
				if (this.userInfo == undefined || !token) {
					// this.$message.warning('账号暂未登录');
					this.$root.loginShow = true;
					this.isshows = false
					return false;
				}
				if (this.userInfo.userLevelStatus) {
					this.iconShow = true;
				} else {
					this.dialogVisible = true;
				}
			},
			getInfoData() {
				getInfo().then(res => {
					if (res.code == 0) {
						this.texart = res.data.quickContact;
					}
				})
			},
			getDetat(id) {
				getDetail({
						id: id
					}).then(res => {
						this.videoList = res.data.videoList || [];
						let arr = res.data.educationStageList || [];
						let arr2 = res.data.subjectList || [];
						let arr1 = [];
						let arr3 = [];
						arr.forEach((item, index) => {
							arr1.push(item.name)
						})
						arr2.forEach((item, index) => {
							arr3.push(item.name)
						})
						this.tpData.forEach((item, index) => {
							if ((!res.data.moduleStatus || !res.data.moduleContent) && item.name == '专家介绍') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if ((!res.data.mainCourseStatus || !res.data.mainCourse || res.data.mainCourse.length==0) && item.name == '主讲课程') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if ((!res.data.displayStatus || !this.videoList || this.videoList.length==0)  && item.name == '精彩视频') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if ((!res.data.teachingStyleStatus || !res.data.teachingStyle) && item.name == '授课风采') {
								this.tpData.splice(index, 1);
							}
						})
						this.tpData.forEach((item, index) => {
							if ((!res.data.teachingCaseStatus || !res.data.teachingCase || res.data.teachingCase.length==0) && item.name == '授课案例') {
								this.tpData.splice(index, 1);
							}
						})
						if (res.data.teachingStyle) {
							res.data.teachingStyle = res.data.teachingStyle.replace(/<img/g,
								'<img mode="widthFix" style="width: 98%;height: auto;"');
						}
						this.details = res.data;
						this.educationStageList = arr1;
						this.subjectList = arr3;

					})
					.catch(error => {
					});
			},
			// 剩余解锁数量
			getNum() {
				getMyLevel().then(res => {
						console.log(res, '+++')
						
						let num = 0;
						for(var key in res.data) {
							num += res.data[key].endLockNum;
						}
						
						this.nums = num;
					})
					.catch(error => {

					});
			},
			goUrl(item) {
				window.open(item.livingUrl);
			},
			unlock(e) {
				// 判断是否登录
				let token = localStorage.getItem('keyToken');
				if (this.userInfo == undefined || !token) {
					// this.$message.warning('账号暂未登录');
					this.$root.loginShow = true;
					this.isshows = false
					return false;
				}
				// 登录成功后 提示开通会员
				this.vip = 1;
				// 先判断是否是会员身份
				// 如是会员 
				// 判断是否解锁 1.解锁的话弹专家二维码 如没有专家二维码 谈助教二维码
				// 2.如未解锁 弹解锁弹窗 获取剩余解锁数量 调取解锁专家接口
				// 如不是会员 让去开通会员
				if (this.userInfo.userLevelStatus == true) {
					if (this.details.lockStatus == true) {
						this.dialogImmediately = true;
					} else {
						this.dialogVisibleTitle = true;
					}
				} else {
					this.dialogVisible = true;
				}
				// if (e == true) {
				//     this.dialogVisibleTitle = true;
				// }
				// if (e == 1) {
				//     this.dialogVisible = true;
				// } else if (e == 2) {
				//     this.dialogVisible = true;
				// }
				// this.dialogVisible = true;
				// this.vip = e;
				// this.$confirm('确认关闭？')
				//           .then(_ => {
				//             done();
				//           })
				//           .catch(_ => {});
				// 
			},
			handleClose() {
				this.dialogVisible = false;
				this.dialogVisibleTitle = false;
				this.dialogImmediately = false;
				this.show1 = !this.show1;
			},
			activate() {
				// this.$route.push('')
				// let token = localStorage.getItem('keyToken');
				// if(!token){
				// 	this.dialogVisible = false;
				// 	this.$root.loginShow = true;
				// }else{
				this.$router.push('/personal/member/activateMembership')
				// }
				// this.dialogVisible = false;
				// this.dialogVisibleTitle = true;
			},
			immediately(id) {
				// this.dialogVisibleTitle = false;
				// this.dialogImmediately = true;
				// 解锁专家
				getUnlock(id).then(res => {
						if (res.code == 0) {
							this.getDetat(this.zjId);
							this.dialogImmediately = true;
						}
					})
					.catch(error => {

					});
			},
			copy() {
				this.$copyText(this.texart).then((e) => {
					alert('复制成功')
					// console.log(e)
				}, (e) => {
					alert('Can not copy')
					// console.log(e)
				})
			},
			systemChange(val, index) {
				console.log(index, 'index')
				this.selectedIndex = index;
				const targetElement = document.getElementById(val.id);
				if (targetElement) {
					// 将页面滚动到目标位置
					window.scrollTo({
						top: targetElement.offsetTop,
						behavior: 'smooth' // 平滑滚动效果
					});
				} else {
					console.error("未找到目标元素");
				}
			},
			collectZj(id) {
				let params = {
					id: id
				}
				getUserCollect(id).then(res => {
						console.log(res, '--')
						if (res.code == 0) {
							this.details.collectStatus = true;
							this.scShow = true;
							setTimeout(function() {
								document.getElementById('myDiv').style.display = "none";
							}, 2000)
							// this.getDetat(id)
						} else {
							if (res.code == 401) {
								this.$root.loginShow = true;
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						}
					})
					.catch(error => {

					});

			},
			collectQx(id) {
				let params = {
					ids: id
				}
				getDeleteCollect(params).then(res => {
						console.log(res, '--')
						if (res.code == 0) {
							this.details.collectStatus = false;
							this.scShow = false;
						} else {
							if (res.code == 401) {
								this.$root.loginShow = true;
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						}
					})
					.catch(error => {

					});

			},

		}
	}
</script>


<style scoped>
	.pad-16 {
		padding: 16px;

	}

	.box-shadow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.is-flex {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	/* .is-flex img {
        width: 35px;
        height: 35px;
    } */
	.wid-100 {
		position: relative;
		width: 100%;
	}

	.titles {
		position: absolute;
		left: 8px;
		top: 12px;
	}

	.tit-1 {
		font-family: font5;
		font-size: 20px;
		color: #222222;
		margin-right: 8px;
	}

	.titles span {
		font-family: font3;
		font-size: 14px;
		color: #999999;
	}

	.hed-img {
		width: 8vw;
		height: 8vw;
		/* width: 136px;
		height: 136px; */
		/* padding-right: 16px; */
		margin-right: 16px;

		img {
			border-radius: 8px;
		}
	}

	.sex-img {
		width: 40px;
		height: 33px;
	}

	.name-1 {
		font-size: 20px;
		font-family: font5;
		padding-right: 9px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		color: #222222;
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
		/* white-space: nowrap; */
	}

	.name-4 {
		width: 60px;
		color: #222222;
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
	}

	.dianji img {
		width: 18px;
		height: 19px;
		padding-right: 8px;
	}

	.dianji .cool-1,
	.dianji .cool-2 {
		padding: 0.5rem 1rem;
		border-radius: 2.1875rem;
	}

	.cool-1 {
		border: 1px solid #FBB54C;
	}

	.cool-2 {
		background: #F0F5FF;
	}

	.cool-1 .name-3 {
		color: #FBB54C !important;
	}

	.cool-1 .name-4 {
		color: #FBB54C !important;
	}

	.cool-3 .name-4 {
		color: #FBB54C;
	}

	.cool-2 .name-3 {
		color: #3377FF !important;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.mb-12 {
		margin-bottom: 12px;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.flex-tab {
		border-radius: 8px;
	}

	.flex-tab p {
		width: 25%;
		color: #666666;
		font-size: 14px;
		text-align: center;
		padding: 16px 0;
		background: #FAFAFA;
		font-family: font3;
	}

	.flex-tab .p-active {
		background: #3377FF;
		color: #FFFFFF;
		font-family: font5;
	}

	.flex-tab p:first-child {
		border-radius: 0.5rem 0 0 0.5rem;
	}

	.flex-tab p:last-child {
		border-radius: 0 0.5rem 0.5rem 0;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.left-p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		font-weight: normal;
		padding-left: 10px;
	}

	.goodat p {
		color: #3377FF;
		font-size: 14px;
		font-family: font3;
		padding: 4px 16px;
		background: #F0F5FF;
		border-radius: 52px 52px 52px 52px;
		margin-right: 16px;
		white-space: nowrap;
	}

	.align-base {
		align-items: baseline;
	}

	.title-p {
		font-size: 16px;
		color: #222222;
		font-family: font5;
		font-weight: normal;
	}

	.yijiesuo div:last-child {
		margin-bottom: 0;
	}

	.jiesuo-1 p {
		color: #3377FF;
		font-family: font3;
		font-weight: normal;
		font-size: 14px;
		padding-left: 8px;
		cursor: pointer;
	}

	.jiesuo-1 img {
		width: 19px;
		height: 19px;
	}

	.videos p {
		padding: 12px 0 12px 8px;
		border: 1px solid #EFEFEF;
		border-radius: 0 0 8px 8px;
		border-top: none;
	}

	.more p {
		color: #666666;
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
		padding-right: 8px;
	}

	.lists-1 {
		font-weight: normal;
		font-size: 14px;
		line-height: 21px;
		padding: 16px 0;
		border-bottom: 1px solid #EFEFEF;
	}

	.lists-1:last-child {
		border-bottom: none;
	}

	.lists-1 p:first-child {
		color: #222222;
		font-family: font5;
	}

	.lists-1 p:last-child {
		color: #999999;
		font-family: font3;
	}

	.cool-3,
	.cool-4 {
		padding: 12.5px 56px;
		border-radius: 4px 4px 4px 4px;
	}

	.cool-3 {
		border: 1px solid #FBB54C;
		margin-right: 50px;
	}

	.cool-3 .name-3 {
		color: #FBB54C !important;
	}

	.cool-4 {
		background: #3377FF;
	}

	.cool-4 .name-3 {
		color: #FFFFFF !important;
	}

	/deep/.el-dialog__headerbtn {
		background: url("../../assets/expert/close.png");
		background-size: cover;
		height: 20px;
		width: 20px;

		i {
			display: none;
			/* // 在这里隐藏弹窗默认的关闭图标 */
		}
	}

	/deep/.el-dialog {
		border-radius: 8px 8px 8px 8px;
	}

	.kaitong {
		font-size: 14px;
		font-family: font3;
		color: #FFFFFF;
		padding: 12px 59px;
		background: #3377FF;
		border-radius: 4px;
		width: 30%;
		margin: 0 auto;
		margin-top: 32px;
	}

	.vip {
		text-align: center;
	}

	.vip-p {
		color: #222222;
		font-size: 16px;
		font-family: font5;
	}

	.vip-span {
		color: #3377FF;
	}

	.vip-span-1 {
		font-size: 14px;
		font-family: font3;
		color: #222222;
		margin-bottom: 32px;
	}

	.cancel {
		font-size: 14px;
		font-family: font3;
		color: #3377FF;
		padding: 12px 59px;
		background: #F0F5FF;
		border-radius: 4px;
		margin-right: 16px;
		/* width: 30%;
        margin: 0 auto; */
	}

	.vip-1 {
		font-size: 16px;
		font-family: font3;
		color: #999999;
		margin-bottom: 32px;
	}

	.ctrl-c {
		background: #F0F5FF;
		color: #3377FF;
		padding: 4px 8px;
		border-radius: 48px;
	}

	.ctrl-c p {
		padding-right: 4px;
	}

	.coSucess {
		position: fixed;
		top: 30.5%;
		left: 50%;
		font-weight: normal;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 21px;
		font-family: font5;
		background: rgba(0, 0, 0, 0.4);
		border-radius: 3.5625rem;
		padding: 0.5rem 1.25rem;
		text-align: center;
		/* width: 4%; */
		white-space: nowrap;
		opacity: 1;
	}

	.member-icon {
		/* width: 100%; */
		/* padding: 0 25px; */
		padding-bottom: 30px;
		margin: auto;
	}

	.member-title {
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: bold;
		font-size: 150%;
		color: #222222;
		text-align: center;
	}

	.member-list {
		/* width: 90%; */
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 40px;
	}


	.member-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 45%;
		height: 20%;
		border-radius: 8px;
		padding: 0 1%;
		border: 1px solid #F3F3F3;
		margin-bottom: 8px;
	}


	.member-span {
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: bold;
		font-size: 100%;
		color: #222222;
	}

	.member-img {
		width: 30%;
		height: 30%;
	}


	.member-btn {
		width: 180px;
		height: 46px;
		line-height: 46px;
		background: #3377FF;
		border-radius: 4px;
		text-align: center;
		background-color: #3377FF;
		font-size: 20px;
		font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
		font-weight: normal;
		color: #FFFFFF;
		margin: auto;
		margin-top: 35px;
	}
</style>